import { useEffect, useState } from 'react';
import { serverConfigured } from './config';
import { supabase, useSyncState } from './useSync';

export type Role = 'owner' | 'beheerder';

/** The signed-in user's own role, or null if they aren't an admin / no server is set up. */
export function useRole(): Role | null {
  const userId = useSyncState((s) => s.session?.user.id ?? null);
  // Kept with the user it belongs to, so signing out or in as someone else never shows a stale role.
  const [found, setFound] = useState<{ userId: string; role: Role | null } | null>(null);
  useEffect(() => {
    if (!serverConfigured() || !userId) return;
    let cancelled = false;
    // Admins may see every admin row (policy "see all admins"): ask for our own.
    void supabase()
      .from('team_admins')
      .select('role')
      .eq('user_id', userId)
      .maybeSingle()
      .then(({ data }) => {
        if (!cancelled) setFound({ userId, role: (data?.role as Role | undefined) ?? null });
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);
  return found && found.userId === userId ? found.role : null;
}
